/*
 * @Author: lijinyang
 * @FilePath: /mall-fe/src/comps/Body.tsx
 * @Description: 商城首页入口文件
 */
import { MediaQueryContext, UserContext } from 'libs/contexts';
import { useContext } from 'react';
import AnnouncementModal from 'comps/Announcement';
import { FeatureEnum, isFeatureActive } from 'libs/features';

type BodyProps = {
  children: React.ReactNode;
  bgColor?: string;
};
// 商城首页入口容器组件
export default function Body({ children, bgColor }: BodyProps) {
  const { isMobile } = useContext(MediaQueryContext);
  const userInfo = useContext(UserContext); // 全局用户信息
  return (
    <BodyContent bgColor={bgColor || 'var(--pageBgColor)'}>
      {children}
      {isFeatureActive(FeatureEnum.AnnouncementModal) && userInfo && isMobile && (
        <AnnouncementModal />
      )}
    </BodyContent>
  );
}

function BodyContent({ bgColor, children }: any) {
  return (
    <div className="content">
      <div className="content-body">{children}</div>
      <style jsx>{`
        .content {
          display: table-row;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background-color: ${bgColor};
        }
        .content-body {
          display: table-cell;
        }
      `}</style>
    </div>
  );
}
